import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import { hasAdminAccess } from "../utils/property";
import PageLoader from "../components/PageLoader";

const VERIFY_ACCOUNT_MESSAGE =
  "Please verify your account first, then log in again.";

export default function AdminRoute({ children }) {
  const [state, setState] = useState({
    loading: true,
    user: null,
    profile: null,
    canAccess: false,
  });

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setState({
          loading: false,
          user: null,
          profile: null,
          canAccess: false,
        });
        return;
      }

      try {
        const snapshot = await getDoc(doc(db, "users", user.uid));
        const profile = snapshot.data();
        setState({
          loading: false,
          user,
          profile,
          canAccess: hasAdminAccess(profile, user.email),
        });
      } catch (error) {
        console.error(error);
        setState({
          loading: false,
          user,
          profile: null,
          canAccess: false,
        });
      }
    });

    return () => unsubscribe();
  }, []);

  if (state.loading) {
    return <PageLoader label="Checking access..." />;
  }

  if (!state.user) {
    return <Navigate to="/login" replace />;
  }

  if (!state.canAccess) {
    const needsEmailVerification =
      !state.user.emailVerified &&
      !hasAdminAccess(state.profile, state.user.email);

    return (
      <Navigate
        to="/"
        replace
        state={{
          message: {
            tone: "error",
            text: needsEmailVerification
              ? VERIFY_ACCOUNT_MESSAGE
              : "You do not have permission to access the admin dashboard.",
          },
        }}
      />
    );
  }

  return children;
}
